await import(/* webpackChunkName: "jquery-match-height" */ 'jquery-match-height');

window.am = window.am || {};

window.am.ticket = new function () {
    var that = this;
    that.resizedFinished;
    that.delta = 250;
    that.width = 767;
    that.onResize = function () {
        clearTimeout(that.resizedFinished);
        that.resizedFinished = setTimeout(function () {
            var fieldSelects = $('.lottery__form-field label:not(.label-with-icon > label), .lottery__form-field .label-with-icon');
            // reset height
            fieldSelects.css('height', 'auto');
            // base on resolution bind or unbind match height plugin
            if (window.innerWidth > that.width) {
                fieldSelects.matchHeight({
                    remove: false
                });
            } else {
                fieldSelects.matchHeight({
                    remove: true
                });
            }
        }, that.delta);
    },
    that.init = function () {
        window.addEventListener("resize", that.onResize);
        that.onResize();
    };
};

window.am.ticket.init();